import { render } from "./team-member-settings.vue?vue&type=template&id=04a7f058&scoped=true&ts=true"
import script from "./team-member-settings.vue?vue&type=script&lang=ts"
export * from "./team-member-settings.vue?vue&type=script&lang=ts"

import "./team-member-settings.vue?vue&type=style&index=0&id=04a7f058&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a7f058"]])

export default __exports__